import { render, staticRenderFns } from "./GroupSetting.vue?vue&type=template&id=720b4f8b&"
import script from "./GroupSetting.vue?vue&type=script&lang=ts&"
export * from "./GroupSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports